import React from "react";
import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import styles from "./sidebar-header.module.scss";
import { RootState } from "../../../store";

const SidebarHeader = (): React.JSX.Element => {
  const resourceCenter = useSelector(
    (state: RootState) => state.clientPortalUserInfo?.user?.user?.resourceCentre
  );

  return (
    <div className={styles.header}>
      <img
        alt="Resource Center Logo"
        className={styles.img}
        src={resourceCenter?.resourceCentreLogo?.s3ResourceURL}
      />
      <Typography className={styles.title} variant="h6">
        {resourceCenter?.name}
      </Typography>
    </div>
  );
};

export default SidebarHeader;
